import * as Sentry from '@sentry/browser'

const ALARM_TAG = 'alarm'

export function isAlarmEvent(event: Sentry.ErrorEvent): boolean {
  return event.tags?.[ALARM_TAG] === 'true'
}

type AlarmContext = {
  scope: string
  issueType: string
  extra?: Record<string, unknown>
}

export function captureAlarm(error: unknown, context: AlarmContext): void {
  Sentry.captureException(error, {
    level: 'error',
    tags: {
      [ALARM_TAG]: 'true',
      sentry_scope: context.scope,
      issue_type: context.issueType,
    },
    extra: context.extra,
    fingerprint: [context.scope, context.issueType],
  })
}
